import * as ngCore from '@angular/core'
import type * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import { TypeChecker } from '@attain-apps/type-guards'

import * as state from '../../../../../../../state'

/** Modal for granting a user survey admin access */
@ngCore.Component({
  imports: [
    ds.button.Component,
    ds.input.select.single.Component,
    ds.layout.widget.Component,
    ds.overlay.centered.Component,
  ],
  selector: 'atn-space-lite-add-survey-admin-modal',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.space.userAccess.surveyAdmins.Collection} */
  public readonly surveyAdminsEc = ngCore.inject(
    state.space.userAccess.surveyAdmins.Collection,
  )

  /** @see {@link state.space.userAccess.users.Collection} */
  private readonly _usersEc = ngCore.inject(
    state.space.userAccess.users.Collection,
  )

  /** Ids of the users who do not administer the survey yet */
  private readonly _assignableUserIdsSg = ngCore.computed(
    (
      userIds = this._usersEc.plugins.currentListPlugin.feature.selectors.ids.asSignal(),
      surveyAdminUserIds = new Set(
        this.surveyAdminsEc.plugins.currentListPlugin.feature.selectors.entities
          .asSignal()
          .map(({ userId }) => userId),
      ),
    ) => userIds.filter(userId => !surveyAdminUserIds.has(userId)),
  )

  /** The items to display in the users dropdown */
  public readonly userSelectItemsSg = ngCore.computed<
    readonly ds.input.select.models.Item<ents.extra.space.User.Id>[]
  >((assignableUsers = this._usersEc.plugins.cachePlugin.feature.selectors
    .getCachedEntities(this._assignableUserIdsSg())
    .asSignal()) =>
    assignableUsers.filter(TypeChecker.isNotNullish.raw).map(user => ({
      label: `${user.id} - ${user.name}`,
      value: user.id,
    })),
  )

  /** The user the survey admin access is being granted to */
  public readonly selectedUserIdSg = ngCore.computed(
    (
      userAccess = this.surveyAdminsEc.plugins.currentEntityPlugin.feature.selectors
        .getEditedEntity()
        .asSignal(),
    ) => userAccess?.userId,
  )

  /** Stores the user the survey admin access is granted to */
  public selectedUserChangedHandler(
    selectedUserId: ents.extra.space.User.Id | undefined,
  ): void {
    this.surveyAdminsEc.plugins.editingPlugin.feature.actions.edit
      .from('Space.UserAccess.AddSurveyAdminModal.User.Changed')
      .dispatch({ edit: { input: { userId: selectedUserId } } })
  }

  /** Grants the survey admin access */
  public saveClickHandler(): void {
    this.surveyAdminsEc.plugins.editingPlugin.feature.actions.submit
      .from('Space.UserAccess.AddSurveyAdminModal.Save.Clicked')
      .dispatch({ current: true })
  }

  /** Closes the modal without granting anything */
  public cancelClickHandler(): void {
    this.surveyAdminsEc.plugins.editingPlugin.feature.actions.discard
      .from('Space.UserAccess.AddSurveyAdminModal.Cancel.Clicked')
      .dispatch({ current: true })
  }
}
